export function downloadBlobAsFile(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const escapeCsvValue = (value: string): string => {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function generateCSVContent<Data extends Record<string, unknown>>({
  headers,
  data,
  formatCsvRow
}: {
  headers?: string[]
  data: Data[]
  formatCsvRow?: (row: Data) => string[]
}): string {
  const headerLine = headers ? headers.map(escapeCsvValue).join(',') + '\n' : ''
  const csvRows = data.map((row) => {
    if (formatCsvRow) {
      return formatCsvRow(row)
        .map((value) => escapeCsvValue(String(value)))
        .join(',')
    }
    return Object.values(row)
      .map((value) => escapeCsvValue(String(value)))
      .join(',')
  })
  return headerLine + csvRows.join('\n') + (csvRows.length ? '\n' : '')
}
